"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSliderOptions = exports.useCarouselHeight = exports.TITLE_MOBILE_HEIGHT = exports.TITLE_DESKTOP_HEIGHT = exports.PRODUCTS_GAP = exports.PAGINATION_HEIGHT = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _internal = require("../../hooks/internal");
var _utils = require("../../utils");
const PRODUCTS_GAP = exports.PRODUCTS_GAP = 4;
const TITLE_DESKTOP_HEIGHT = exports.TITLE_DESKTOP_HEIGHT = 40;
const TITLE_MOBILE_HEIGHT = exports.TITLE_MOBILE_HEIGHT = 35;
const PAGINATION_HEIGHT = exports.PAGINATION_HEIGHT = 28;
const useSliderOptions = ({
  initialProductCode
}) => {
  const {
    products
  } = (0, _internal.useProducts)();
  const {
    index
  } = (0, _utils.getInitialProduct)({
    initialProductCode,
    products
  });
  return (0, _react.useMemo)(() => ({
    navigation: {
      showArrows: false
    },
    pagination: {
      show: false
    },
    slider: {
      initial: index,
      loop: false
    }
  }), [index]);
};
exports.useSliderOptions = useSliderOptions;
const useCarouselHeight = () => {
  const theme = (0, _mui.useTheme)();
  const {
    originalItemCode
  } = (0, _internal.useSharedConfiguration)();
  const {
    products
  } = (0, _internal.useProducts)();
  const gap = theme.spacing(PRODUCTS_GAP);
  return (0, _react.useMemo)(() => {
    const hasPagination = products.length > 1;
    const titleDeductionDesktop = originalItemCode ? ` - ${TITLE_DESKTOP_HEIGHT}px - ${gap}` : '';
    const titleDeductionMobile = originalItemCode ? ` - ${TITLE_MOBILE_HEIGHT}px - ${gap}` : '';
    const paginationDeduction = hasPagination ? ` - ${PAGINATION_HEIGHT}px - ${gap}` : '';
    const desktopHeight = `calc(100%${titleDeductionDesktop}${paginationDeduction})`;
    const mobileHeight = `calc(100%${titleDeductionMobile}${paginationDeduction})`;
    return {
      desktopHeight,
      mobileHeight
    };
  }, [gap, originalItemCode, products.length]);
};
exports.useCarouselHeight = useCarouselHeight;
